<script>
import WarehouseArea from "@/router/views/property/settings-template/warehouse-component/area.vue";

export default {
  name: "warehouse-area",
  components: {
    WarehouseArea
  },
  props: {
    areaRow: {
      type: Object,
      required: true
    },
    parentRow: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    addArea(row) {
      this.$emit("addArea", row);
    },
    updateArea(props) {
      this.$emit("updateArea", {
        areaRow: props.areaRow,
        parentRow: props.parentRow
      });
    },
    deleteArea(props) {
      this.$emit("deleteArea", {
        areaRow: props.areaRow,
        parentRow: props.parentRow
      });
    },
    showAreaChildren() {
      if (!this.areaRow.withChild) return;

      this.areaRow.itemVisible = !this.areaRow.itemVisible;
      if (this.areaRow.itemVisible) {
        this.loading = true;
        setTimeout(() => {
          this.$store
            .dispatch(
              "propertywarehouse/GetLocationAreaByParent",
              this.areaRow.id
            )
            .then((res) => {
              res.data.forEach((area) => {
                area.areaChildren = [];
                area.itemVisible = false;
              });
              this.areaRow.areaChildren = res.data;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
              this.showToast("Something went wrong - Areas!", "error");
            });
        }, 1000);
      }
    }
  }
};
</script>

<template>
  <div>
    <div>
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-3">
          <div @click="showAreaChildren()">
            <i
              class="bx bx-chevron-right rotate font-size-20 cursor-pointer"
              :class="{
                'rotate-90': areaRow.itemVisible
              }"
            ></i>
          </div>
          <div>
            <b class="text-white">{{ areaRow.areaName }}</b>
            <div>
              {{ areaRow.areaDescription }}
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center gap-3">
          <a
            v-if="!areaRow.withChild"
            href="javascript:void(0);"
            class="text-danger"
            @click="deleteArea({ areaRow, parentRow })"
          >
            <i class="mdi mdi-trash-can font-size-22 me-1"></i>
          </a>
          <a
            href="javascript:void(0);"
            @click="updateArea({ areaRow, parentRow })"
          >
            <i class="mdi mdi-update font-size-22 me-1"></i>
          </a>
          <a
            href="javascript:void(0);"
            class="text-info"
            @click="addArea(areaRow)"
          >
            <i class="mdi mdi-plus font-size-22 me-1"></i>
          </a>
        </div>
      </div>
      <hr />
    </div>
    <b-collapse :visible="areaRow.itemVisible" role="tabpanel">
      <div v-if="areaRow.itemVisible" class="mt-2 ms-4">
        <div v-if="loading">
          <div class="d-flex align-items-center mb-5">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <span>Loading...</span>
          </div>
        </div>
        <div v-else-if="areaRow.areaChildren.length > 0">
          <div v-for="childRow in areaRow.areaChildren" :key="childRow.id">
            <warehouse-area
              :areaRow="childRow"
              :parentRow="areaRow"
              @addArea="addArea($event)"
              @updateArea="updateArea($event)"
              @deleteArea="deleteArea($event)"
            ></warehouse-area>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>
